module.exports = __webpack_public_path__ + "static/media/clock-overtime.195bfa1e.svg";